/**
 * Created by Qingger Corp.
 * User: yangzihua
 * Date: 2019/6/17
 * Time: 20:45
 * Desc: 云店设置-分类配置-商品分类配置
 */

import { Component, Provide, Vue, Watch } from 'vue-property-decorator';
import type { ElForm } from 'element-ui/types/form';
import CircularJSON from 'circular-json';
import cloneDeep from 'lodash/cloneDeep';
import { result } from 'lodash';
import primaryGoods from './primaryGoods';
import { IPSService } from '@/services/ipsServices';
import { QinggerLibUtils, noop } from '@/util';
import Utils from '@/library/utils';
import baseAPIService from '@/services/base/baseAPIService';
import { EmpServiceAPIActions } from '@/services/empService';
import { appEnvConfig } from '@/configs/appConfigs';
import { Functions } from '@/library/utils/functions';
import bindClassDialog from '@/views/components/newDisplayConfig/bindClassDialog';
const isset = QinggerLibUtils.isset;

const TopClassListService = ['getTopClassList', 'getTopClassList', 'getTopClassList', 'getTopClassList', 'getTopClassList'];

const BatchClassService = ['batchOperationClass', 'batchOperationClass', 'siteClassEditStateNew'];

const RelateClassService = ['relateAttributeOfClass', 'relateAttributeOfClass', 'productRelateAttr'];

const UpdateLevelNodeClassService = ['updateLevelNodeClass', 'updateLevelNodeClass', 'siteClassEditNew'];

const UpdateLevelClassService = ['updateLevelClass', 'updateLevelClass', 'siteClassEditNew'];

const ClassListService = ['getLevelClassList', 'getLevelClassList', 'siteClassListNew'];

@Component({
  components: {},
})
export default class GoodsCategory extends Vue {
  /* 数据 */
  $refs: {
    lableForm: ElForm;
    addForm: ElForm;
    tree: ElForm;
  };

  /**
   * loading状态
   * @type {boolean}
   */
  public loadingState = false;

  /**
   * 商品分类列表
   * @type {Array<any>}
   */
  public levelClassList: Array<any> = [];

  /**
   * 表头
   * @type {boolean}
   */
  public tableColumn: Array<any> = [{ text: '分类名称', dataIndex: 'className' }];

  /**
   * 上级分类列表
   * @type {any[]}
   */
  public topClass: ItemArray<ProductClassInfo> = [];

  /**
   * 是否默认展开所有树
   * @type {boolean}
   */
  public ifExpandAll = false;

  /**
   * 是否新增层级分类
   * @type {boolean}
   */
  public addClass = false;

  /**
   * 新增层级分类/新增下级
   * @type {string}
   */
  public addTitle = '';

  /**
   * 新建的分类项
   * @type {Array<ProductClassInfo>}
   */
  public classItem: Array<ProductClassInfo> = [];

  /**
   * 被选中的上级分类
   * @type {ProductClassInfo}
   */
  public selectForm: ProductClassInfo = {};

  /**
   * corpId
   */
  public corpId = baseAPIService.resolveCorpId();

  /**
   * 新增分类表单数据
   * @type {ItemObject}
   */
  public addForm: ItemObject = {
    parentId: 0,
    sgId: 0,
    siteId: 0,
    classList: this.classItem,
    classState: 1,
  };

  /**
   * 选择的上级分类
   * @type {any[]}
   */
  public topValue: Array<any> = [];

  /**
   * 关联分类：已选中的下拉标签
   * @type {ItemArray<RelationClass>}
   */
  public selectConnectedClass: ItemArray<string> = [];

  coupon = 0;
  /**
   * 关联分类：下拉标签
   * @type {ItemArray<RelationClass>}
   */
  public connectedClass: ItemArray<RelationClass> = [];

  /**
   * 选择的标签对应的属性列表
   * @type {any[]}
   */
  public connectedClassSelected: ItemArray<any> = [];

  /**
   * 选择关联的属性
   * @type {ItemObject}
   */
  public attrSelected: ItemObject = {
    classId: 0,
    attrList: [],
  };

  /**
   * 鼠标悬停的项--下标
   * @type {number}
   */
  public index = -1;

  /**
   * 绑定主档分类弹窗是否显示
   * @type {boolean}
   */
  public isBindMainVisible = false;

  /**
   * 图片放大弹窗是否显示
   * @type {boolean}
   */
  public isMagnifyPopShow = false;

  /**
   * 当前要放大的图片
   * @type {string}
   */
  public curPic = '';

  /**
   * 当前图片上传组件的索引
   * @type {number}
   */
  public curPicUploaderIndex = 0;

  /**
   * 一级分类弹窗是否显示
   * @type {boolean}
   */
  public isAddFirstClass = false;

  /**
   * 上级分类名称
   * @type {string}
   */
  public topClassName = '';

  /**
   * 上级分类Id
   * @type {string}
   */
  public topId: string | number = '';

  /**
   * 关联分类 标签选择限制
   * @type {number}
   */
  public limitNum = 6;

  /**
   * 图片上传地址
   * @type {string}
   */
  public fileTpConfig = `${Functions.ipsHostUrlApi()}/pic/upload/withOut/key`;

  /**
   * token
   * @type {{Authorization: string}}
   */
  public tokenData: ItemObject = {
    Authorization: `Bearer ${EmpServiceAPIActions.getTokenFromCache().token}`,
  };

  /**
   * 错误图片
   */
  public errorImg: any = require('../../../../static/img/boxBgImg.svg');

  // 编辑商品分类
  public isEditGoodsVisible = false;

  public isEditVisible = false;

  public labelData: any = {};

  classData = {};
  // 运营模式
  public mode = 0; // 网点Id
  public siteId = 0;

  // 主档分类平铺列表
  public attributeStore = [];

  // 筛选项列表
  public filterList = [];

  /* 方法 */

  public checkedKeys() {
    const result = [...this.attrSelected.attrList.map(v => v.attrValues.split(','))].flat();
    return result;
  }

  /**
   * 获取层级列表
   * @return null
   */
  public getLevelClassList(): void {
    const postParams = {
      sgId: this.$route.params.id,
      classId: 0,
    };
    IPSService.getLevelClassList({ postParams }).then((res) => {
      if (isset(res, 'list')) {
        const list = cloneDeep(Utils.MSDataTransfer.treeToArray(res.list, null, null, this.ifExpandAll));
        if (!this.levelClassList || !this.levelClassList.length) {
          this.levelClassList = list;
        } else {
          this.levelClassList = list.map((v) => {
            const find = this.levelClassList.find(val => val.classId === v.classId);
            if (find) {
              v.isEditing = find.isEditing;
              v.isHovered = find.isHovered;
              v.parentId = find.parentId;
              v._expanded = find._expanded;
              v._level = find._level;
              v._show = find._show;
            }
            return v;
          });
        }
      }
    });
  }

  /**
   * 获取上级分类列表(仅一级二级)
   */
  public getTopClassList(): void {
    const queryParams = {
      sgId: this.$route.params.id,
    };
    IPSService[TopClassListService[this.mode]]({ queryParams }).then((res) => {
      if (res) {
        this.topClass = res.list;
        this.topClass.push({
          classId: 0,
          className: '默认顶级分类',
          classSort: 1,
          classPic: '',
        });
      }
    });
  }

  /**
   * 显示行
   * @param {any} row
   * @return {any}
   */
  public showTr({ row }): any {
    const show = row._parent ? row._parent._expanded && row._parent._show : true;
    row._show = show;
    return show ? '' : 'display:none;';
  }

  /**
   * 显示单元格
   * @param {any} row
   * @return {any}
   */
  public showCell({ row }): any {
    const show = row._parent ? row._parent._expanded && row._parent._show : true;
    row._show = show;
    return show ? '' : 'display:none;';
  }

  /**
   * 显示层级关系的空格和图标
   * @param {number} index
   * @return {boolean}
   */
  public spaceIconShow(index: number): boolean {
    return index === 0;
  }

  /**
   * 点击展开和关闭的时候，图标的切换
   * @param {number} index
   * @param {ItemObject} record
   * @return {boolean}
   */
  public toggleIconShow(index: number, record: ItemObject): boolean {
    return index === 0 && record.children && record.children.length > 0;
  }

  /**
   * 展开下级
   * @param trIndex
   */
  public expandLevel(trIndex) {
    const record = this.levelClassList[trIndex];
    record._expanded = !record._expanded;
    this.$forceUpdate();
  }

  /**
   * 失去焦点  排序
   * @param value
   */
  public sortBlur(value) {
    if (value.classSort) {
      if (this.mode == 2 && Number(this.$route.params.siteId)) {
        this.sortSiteClass(value);
      } else {
        this.sortSgClass(value);
      }
    } else {
      this.$message.warning('请填写排序');
    }
  }

  // 网点的分类排序
  public sortSiteClass(value) {
    const copyClass = cloneDeep(this.levelClassList);
    copyClass.forEach((v) => {
      if (v.children) {
        v.children.forEach((val) => {
          val._parent = Object.assign({}, v, { children: [] });
        });
      }
    });
    const sortItem = copyClass.find(v => v.classId === (value.parentId || value.classId));
    let classList = [];
    if (value.parentId) {
      classList = (sortItem.children || []).filter(v => v.classId === value.classId);
    } else {
      classList = [sortItem];
    }
    IPSService.siteClassEditNew({
      postParams: {
        siteId: this.siteId,
        classState: value.classState,
        parentId: value.parentId || value.classId,
        classList,
      },
    }).then((response) => {
      this.$message.success('设置成功');
      this.getClassList();
    });
  }

  // 网点组的分类排序
  public sortSgClass(value) {
    const postParams = {
      classId: value.classId,
      classSort: value.classSort,
    };
    IPSService.updateClassSort({ postParams }).then((res) => {
      this.$message.success('设置成功');
      this.getClassList();
    });
  }

  /**
   * 禁用/启用 操作
   * @param classId
   * @param type
   */
  public operationClass(classId, type): void {
    const postParams = {
      classIdList: [classId],
      classState: type,
      siteId: this.siteId,
    };
    IPSService[BatchClassService[this.mode]]({ postParams }).then((res) => {
      this.$message.success('操作成功');
      this.getClassList();
    });
  }

  /**
   * 删除操作
   * @param row
   * @param type
   */
  public deleteClass(row, type): void {
    let message = '是否删除此层级分类?';
    if (row.children && row.children.length > 0) {
      message = '该分类下的子分类将会一起删除，是否删除?';
    }
    this.$confirm(message, '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }).then(() => {
      const postParams = {
        classIdList: [row.classId],
        classState: type,
        classId: row.classId,
        siteId: this.siteId,
      };
      IPSService[this.mode == 2 ? 'productClassDeleteNew' : BatchClassService[this.mode]]({ postParams }).then((res) => {
        this.$message.success('删除成功');
        this.getClassList();
        if (this.mode === 1) {
          this.getTopClassList();
        }
      });
    });
  }

  /**
   * 提交关联分类/绑定主档分类
   * @return null
   */
  public onSubmitRelated(): void {
    this.attrSelected.attrList = this.connectedClassSelected.map((v) => {
      return {
        attrCode: v.value_no,
        attrName: v.attrName,
        attrValues: v.selectValues && v.selectValues.length ? v.selectValues.join(',') : '',
      };
    });
    // if (this.attrSelected.attrList.length < 1) {
    //   this.$message.warning("请选择分类");
    //   return;
    // };
    this.attrSelected.attrList = this.attrSelected.attrList.filter(v => !!v.attrValues);
    const postParams = this.attrSelected;
    IPSService[RelateClassService[this.mode]]({
      postParams: {
        list: postParams.attrList,
        classId: postParams.classId,
      },
    }).then((res) => {
      this.$message.success('绑定成功');
      this.isBindMainVisible = false;
      this.getClassList();
    });
  }

  /**
   * 选中的关联分类发生变化时
   */
  public selectClassChange(): void {
    this.connectedClassSelected = this.connectedClass.filter(v => (this.selectConnectedClass as Array<string>).includes(v.value_no));
  }

  /**
   * 选择的上级分类
   */
  public selectedTop(value): void {
    this.selectForm = {};
    const data = this.getClassSelect(value, this.topClass);
    // @ts-expect-error
    this.selectForm = data.length > 1 ? data[data.length - 1] : data[0];
  }

  /**
   * 返回选中的上级分类
   * @param val
   * @param opt
   * @returns {any}
   */
  public getClassSelect(val, opt): void {
    return val.map((value, index, array) => {
      for (const itm of opt) {
        if (itm.classId == value) {
          opt = itm.children;
          return itm;
        }
      }
      return null;
    });
  }

  /**
   * 获取关联分类
   */
  public getAttributeList() {
    return IPSService.getAttrTreeList().then((res) => {
      return res.list.map((v) => {
        v.value_name = v.attrName;
        v.value_no = v.attrCode;
        return v;
      });
    });
  }

  /**
   * 绑定主档分类弹窗
   * @param {ItemObject} row
   * @return null
   */
  public onBindMainVisible(row: ItemObject) {
    if (this.mode === 1) {
      this.isBindMainVisible = true;
      this.attrSelected.classId = row.classId;
      this.attrSelected.attrList = row.relationList;
      this.selectConnectedClass = [];
      this.connectedClassSelected = [];
      if (row.relationList && row.relationList.length > 0) {
        this.selectConnectedClass = row.relationList.map(item => item.attrCode);
        this.connectedClassSelected = this.connectedClass.filter(v => this.selectConnectedClass.includes(v.attrCode));
      }
    } else {
      console.log(
        '23232352646',
        row.relationList.map(v => Number(v)),
      );
      bindClassDialog
        .open({
          defaultCheckedKeys: row.relationList.map(v => Number(v)),
          dataSource: this.filterList,
          props: { children: 'children', label: 'className' },
          nodeKey: 'classId',
          title: '绑定筛选项',
          formTitle: '绑定至筛选项',
          tips: '请先设置好筛选项，并通过绑定筛选项配置分类',
        })
        .then((result) => {
          const leafeList = result.filter(v => v.isLeafe);
          IPSService.productRelateAttr({
            postParams: {
              list: leafeList.map(v => v.classId),
              classId: row.classId,
            },
          }).then((res) => {
            this.$message.success('绑定成功');
            this.isBindMainVisible = false;
            this.getClassList();
          });
        }, noop);
    }
  }

  /**
   * 删除已上传图片
   * @param {number} index
   * @return null
   */
  public onDeletePic(index: number): void {
    this.addForm.classList[index].classPic = '';
  }

  /**
   * 图片上传之前
   * @param {ItemObject} file
   * @return boolean
   */
  public onBeforeUpload(file: ItemObject): boolean {
    const isJpg = file.type === 'image/jpeg';
    const isPng = file.type === 'image/png';
    const isGif = file.type === 'image/gif';
    const LtSize = file.size / 1024 <= 300;
    if (!isJpg && !isPng && !isGif) {
      this.$message.error('上传图片只能是 JPG/JPEG/PNG/GIF 格式!');
      return false;
    }
    if (!LtSize) {
      this.$message.error('上传图片大小不能超过 300Kb!');
      return false;
    }
    return (isJpg || isPng || isGif) && LtSize;
  }

  /**
   * 图片上传成功时的处理
   * @param res
   * @param file
   */
  public uploadImgSuccess(res: HttpAPIRetItem<any>, file: any) {
    this.addForm.classList[this.curPicUploaderIndex].classPic = res.content;
  }

  public upLoadEditImgSuccess(res: HttpAPIRetItem<any>, file: any) {
    this.labelData.classPic = res.content;
  }

  public openEditDialog(row) {
    this.isEditGoodsVisible = true;
    this.labelData = cloneDeep(row);
  }

  public openPrimaryEditDialog(index, row) {
    primaryGoods
      .open({
        data: [
          {
            desc: {
              list: this.levelClassList[index].advInfo.list || [],
            },
            fieldType: 'HotAd',
            isActived: false,
            hotAdvert: 1,
            className: row.className,
          },
        ],
        attrButeList: this.connectedClass,
        coupon: this.coupon,
        classId: row.classId,
        mod: this.mode,
        empCode: this.$store.state.empCode,
        sgId: +this.$route.params.sgId,
        siteCodes: [this.$route.params.code],
        siteId: this.siteId,
      })
      .then(
        (result) => {
          this.getClassList();
        },
        () => {
          this.getClassList();
        },
      );
  }

  // 获取优惠券配置
  getCouponConfig() {
    return IPSService.siteGroupConfig({
      postParams: {
        sgId: +this.$route.params.sgId || +this.$route.params.id,
      },
    }).then((res) => {
      return res.isOpenExchangeCoupon || 0;
    });
  }

  public onClearEditForm() {
    this.labelData = {};
    this.isEditGoodsVisible = false;
  }

  public onDeletePicEdit() {
    this.labelData.classPic = '';
  }

  public onSubmitEdit() {
    this.$refs.lableForm.validate((flage) => {
      if (flage) {
        const postParams = {
          sgId: Number(this.$route.params.id),
          classId: this.labelData.parentId,
          siteId: this.siteId,
          classList: [
            {
              classId: this.labelData.classId, // 分类ID，0表示新增
              className: this.labelData.className, // 分类名称
              classSort: this.labelData.classSort, // 排序
              classPic: this.labelData.classPic, // 图片
            },
          ],
        };
        IPSService[UpdateLevelNodeClassService[this.mode]]({ postParams }).then(
          (res) => {
            this.$message.success('修改成功');
            this.labelData = {};
            this.isEditGoodsVisible = false;
            this.getClassList();
          },
          () => {
            this.$message.error('修改失败');
          },
        );
      }
    });
  }

  /**
   * 图片上传失败
   * @return null
   */

  public uploadImgError() {
    this.$message.error('图片上传失败');
  }

  /**
   * 图片放大
   * @param {string} item
   * @return null
   */
  public onMagnifyPic(item: string): void {
    this.curPic = item;
    this.isMagnifyPopShow = true;
  }

  /**
   * 获取当前上传组件的索引
   * @param { number } index
   * @returns null
   */
  public onGetCurUploadIndex(index: number): void {
    this.curPicUploaderIndex = index;
  }

  /**
   * 添加一级分类弹窗
   * @return null
   */
  public onFirstClassVisible(): void {
    this.addTitle = '添加一级分类';
    this.isAddFirstClass = true;
    this.addClass = true;
    this.topClassName = '';
    this.topValue = [];
    this.topId = 0;
    this.addForm.classList.push({
      classId: 0,
      className: '',
      classSort: this.addForm.classList.length + 1,
      classPic: '',
    });
  }

  /**
   * 添加二级分类弹窗
   * @param index
   * @param row
   * @return null
   */
  public onSecondClassVisible(index, row): void {
    this.addTitle = '添加二级分类';
    this.isAddFirstClass = false;
    this.addClass = true;
    this.topValue = [];
    this.topId = row.classId;
    this.topClassName = row.className;
    this.topValue.push(row.classId);
    if (isset(row, '_parent')) {
      this.topValue.unshift(row._parent.classId);
    }
    this.selectedTop(this.topValue);
    this.addForm.classList.push({
      classId: 0,
      className: '',
      classSort: this.addForm.classList.length + 1,
      classPic: '',
    });
  }

  /**
   * 新增层级分类/新增下级
   * @return null
   */
  public onAddLevelClass(): void {
    if (this.addForm.classList.length < 1) {
      this.addClass = false;
      return;
    }
    let flag = true;
    this.addForm.sgId = Number.parseInt(this.$route.params.id) || Number.parseInt(this.$route.params.sgId) || 0;
    this.addForm.parentId = this.isAddFirstClass ? 0 : this.topId;
    this.addForm.siteId = this.siteId;
    this.addForm.classList.forEach((item: any) => {
      item.className = item.className.replace(/(^\s+)|(\s+$)/g, '');
      // 判断二级分类是否上传了图片
      if (!this.isAddFirstClass && !item.classPic) {
        flag = false;
        return;
      }
    });
    (this.$refs.addForm as ElForm).validate((valid) => {
      if (valid) {
        // if (!flag) {
        //   this.$message.error("请上传图片！");
        //   return false;
        // }
        const postParams = this.addForm;
        IPSService[UpdateLevelClassService[this.mode]]({ postParams }).then((res) => {
          this.$message.success('新增成功');
          (this.$refs.addForm as ElForm).resetFields();
          this.addClass = false;
          this.getClassList();
          if (this.mode === 1) {
            this.getTopClassList();
          }
        });
      }
    });
  }

  /**
   * 清除表单数据
   * @return null
   */
  public onClearAddForm(): void {
    (this.$refs.addForm as ElForm).resetFields();
    this.classItem = [];
    this.addForm = {
      parentId: 0,
      sgId: 0,
      classList: this.classItem,
      classState: 1,
    };
    this.addClass = false;
  }

  /**
   * 删除待保存分类
   * @param item
   * @return null
   */
  public onDeleteItem(item): void {
    const index = this.addForm.classList.indexOf(item);
    if (index !== -1) {
      this.addForm.classList.splice(index, 1);
    }
  }

  /**
   *  新增同级分类
   * @return null
   */
  public onAddClassItem(): void {
    this.addForm.classList.push({
      classId: 0,
      className: '',
      classSort: this.addForm.classList.length + 1,
      classPic: '',
    });
  }

  /**
   * 选择类型
   * @param value
   */
  public onHandleCheckedCitiesChange(value): void {
    const checkedCount = value.selectValues.length;
    value.checkAll = checkedCount === value.list.length;
    value.isIndeterminate = checkedCount > 0 && checkedCount < value.list.length;
  }

  /**
   * 点击全选按钮
   * @param value
   */
  public onHandleCheckAllChange(value): void {
    const valueList = value.list.map(item => item.value_no); // 所有子分类
    value.selectValues = value.checkAll ? valueList : [];
    value.isIndeterminate = false;
  }

  /**
   * 编辑分类名称
   * @param {ItemObject} item
   * @return null
   */
  public onEditClassName(item: ItemObject): void {
    item.isEditing = true;
  }

  /**
   * 储存分类名称
   * @param {ItemObject} item
   * @return null
   */
  public onSaveClassName(item: ItemObject) {
    if (!item.className || !item.className.trim()) {
      this.$message.warning('请填写分类名称');
      return false;
    }
    if (this.mode == 2 && Number(this.$route.params.siteId)) {
      this.saveSiteClassName(item);
      item.isEditing = false;
    } else {
      this.saveSgClassName(item);
      item.isEditing = false;
    }
  }

  /**
   * 储存网点分类名称
   * @param item
   */
  public saveSiteClassName(item) {
    this.sortSiteClass(item);
  }

  /**
   * 储存网点组分类名称
   * @param {ItemObject} item
   * @return null
   */
  public saveSgClassName(item): void {
    const row = JSON.parse(CircularJSON.stringify(item));
    item.isEditing = false;
    const postParams = {
      classList: [
        {
          classId: row.classId,
          className: row.className,
          classSort: row.classSort,
          classPic: row.classPic,
        },
      ],
      sgId: Number(this.$route.params.id),
      parentId: row.parentId,
      classState: row.classState,
    };
    IPSService.updateLevelClass({ postParams }).then((res) => {
      this.$message.success('设置成功');
      this.mode === 2 ? this.getClassList() : this.getLevelClassList();
    });
  }

  /**
   * 鼠标移入分类名称
   * @param {ItemObject} item
   * @return null
   */
  public onHoverInCateName(item: ItemObject): void {
    item.isHovered = true;
  }

  /**
   * 鼠标移出分类名称
   * @param {ItemObject} item
   * @return null
   */
  public onHoverOutCateName(item: ItemObject): void {
    item.isHovered = false;
  }

  /**
   * 重新格式化图片地址
   * @param {ItemObject} item
   */
  public reCreateImgSrc(item: ItemObject): void {
    item.iconSrc = this.errorImg;
  }

  /**
   * 图片放大弹窗
   * @param {string} pic
   * @return null
   */
  public onMagnifyClassPic(pic: string): void {
    this.curPic = pic;
    this.isMagnifyPopShow = true;
  }

  public checkChange() {
    // @ts-expect-error
    const selectedList: ItemArray = this.$refs.tree.getCheckedNodes() || [];
    this.connectedClassSelected.forEach((val, index) => {
      val.selectValues = [];
      selectedList.forEach((v) => {
        if (v.class_code === val.value_no || v.value_no === val.value_no) {
          val.selectValues.push(v.value_no);
        }
      });
    });
  }

  /* 网点 */

  // 获取网点分类列表
  // getSiteClassList(){
  //   IPSService.siteClassList({
  //     postParams:{
  //       siteId: this.siteId
  //     }
  //   }).then((response) =>{
  //     //@ts-ignore : 使用JS语法
  //     let list = cloneDeep(Utils.MSDataTransfer.treeToArray(response.list, null, null, this.ifExpandAll));
  //     if(!this.levelClassList || !this.levelClassList.length){
  //       this.levelClassList = list;
  //     }else {
  //       this.levelClassList = list.map(v =>{
  //         let find = this.levelClassList.find(val => val.classId === v.classId);
  //         if(!!find){
  //             v.isEditing = find.isEditing;
  //             v.isHovered = find.isHovered;
  //             v.parentId = find.parentId;
  //             v._expanded = find._expanded;
  //             v._level = find._level;
  //             v._show = find._show;
  //         }
  //         return v;
  //       });
  //     };
  //   })
  // }

  /**
   * 获取分类列表
   */
  getClassList() {
    const postParams = {
      siteId: this.siteId,
      sgId: this.$route.params.id,
      classId: 0,
    };
    IPSService[ClassListService[this.mode]]({ postParams }).then((response) => {
      const list = cloneDeep(Utils.MSDataTransfer.treeToArray(response.list, null, null, this.ifExpandAll));
      if (!this.levelClassList || !this.levelClassList.length) {
        this.levelClassList = list;
      } else {
        this.levelClassList = list.map((v) => {
          const find = this.levelClassList.find(val => val.classId === v.classId);
          if (find) {
            v.isEditing = find.isEditing;
            v.isHovered = find.isHovered;
            v.parentId = find.parentId;
            v._expanded = find._expanded;
            v._level = find._level;
            v._show = find._show;
          }
          return v;
        });
      }
    });
  }

  computedTree(list = [], result = []) {
    list.forEach((v) => {
      const item = {
        class_code: '',
        class_name: '',
        value_no: '',
        value_name: '',
      };
      item.class_code = v.attrCode || v.class_code;
      item.class_name = v.attrCode ? v.attrName : this.connectedClass.find(v => v.attrCode === item.class_code).attrName;
      item.value_no = v.attrCode || v.value_no;
      item.value_name = v.attrName || v.value_name;
      result.push(item);
      if (v.list && v.list.length) {
        this.computedTree(v.list, result);
      }
    });
    return result;
  }

  /**
   * 获取关联分类名称
   * @param {string[]} codes
   * @returns string
   */
  getRelationClassName(codes: number[] = []): string {
    let result = [];
    this.filterList.forEach((v) => {
      codes.includes(v.classId) && result.push(v.className);
      if (v.children && v.children.length) {
        result = result.concat(v.children.filter(vl => codes.includes(vl.classId)).map(val => val.className));
      }
    });
    return result.join(',');
  }

  getFilterList() {
    return IPSService.classFilterList({
      postParams: {
        sgId: +this.$route.params.sgId,
      },
    }).then((response) => {
      return response.list;
    });
  }

  /* 周期 */

  /**
   * 当组建创建时
   */
  public async created() {
    this.mode = Number(this.$route.params.mode);
    this.siteId = Number(this.$route.params.siteId);
    this.connectedClass = await this.getAttributeList();
    this.attributeStore = this.computedTree(this.connectedClass);
    this.coupon = await this.getCouponConfig();
    this.getClassList();
    this.mode === 2 && (this.filterList = await this.getFilterList());
    if (this.mode === 1) {
      this.getTopClassList();
    }
  }
}
